import React, { useState, useEffect } from "react";
import "./App.css";
import {
  Competence,
  Screens,
  SelectedPage,
  SubCompetence,
} from "./shared/types";
import useMediaQuery from "./hooks/useMediaQuery";
import Navbar from "./Components/NavBar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./pages/home";
import Footer from "./Components/Footer";
import AboutPage from "./pages/About/About";
import CompetencesPage from "./pages/Competences/competences";
import ProjectPage from "./pages/Projects/projects";
import { ExpandedProjectProvider } from "./Components/ExpandableProjects";
import NewsPage from "./pages/News/news";
import ContactUs from "./pages/ContactUs/contact";
import SubCompetencesPage from "./pages/Competences/subcomptences";
import projects from "./pages/Projects/popolateProjects";
import competencesData from "./pages/Competences/populateCompetences";
import CompetencePage from "./pages/Competences/competencePage";
//import HomePage from "./pages/home";
//import BannerImage from "./assets/background.png";
//import BannerImage2 from "./assets/backgroundPrivate.png";
//import Private from "./pages/home/components/private";
//import Project from "./pages/project";
//import ContactsPage from "./pages/contacts";
//import PublicationsPage from "./pages/publication";
//import Team from "./pages/home/components/team";
//import TeamPage from "./pages/team";
//import ProjectMobile from "./pages/project/indexMobile";
// import Privacy from "./pages/privacy";

function App() {
  const [selectedPage, setSelectedPage] = useState<SelectedPage>(
    SelectedPage.Home
  );
  const [isMenuToggled, setIsMenuToggled] = useState<boolean>(false);

  const isAboveHugeScreen = useMediaQuery(Screens.Huge);
  const isAboveLargeScreen = useMediaQuery(Screens.Large);
  const isAboveMediumScreen = useMediaQuery(Screens.Medium);
  const isAboveSmallScreens = useMediaQuery(Screens.Small);

  const [selectedDiv, setSelectedDiv] = useState<String>("home");
  const [previousDiv, setPreviousDiv] = useState<String>("home");
  const [overBar, setOverBar] = useState<boolean>(false);
  const [buttonHover, setButtonHover] = useState<boolean>(false);

  const [subCompetence, setSubCompetence] = useState<SubCompetence>(
    competencesData[0].items[0]
  );

  const [competence, setCompetence] = useState<Competence>(competencesData[0]);

  function getPageDimens(): String {
    if (isAboveHugeScreen) {
      return " h-[calc(100vh-90px)]";
    } else if (isAboveLargeScreen) {
      return " h-[calc(100vh-90px)]";
    } else if (isAboveMediumScreen || isAboveSmallScreens) {
      return " h-[calc(100vh-60px)]";
    } else {
      return " h-[calc(100vh-60px)]";
    }
  }
  const [showScrollButton, setShowScrollButton] = useState(false);
  useEffect(() => {
    console.log("useEffect is running"); // Check if this log appears

    const handleScroll = () => {
      const scrolled =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      // var scrolled = window.pageYOffset;

      setShowScrollButton(scrolled > 100);
      console.log("Scrolled:", scrolled);
    };

    window.addEventListener("scroll", handleScroll, true); // or yourContainer.addEventListener

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  /*const [showScrollButton, setShowScrollButton] = useState(false);
  useEffect(() => {
    console.log("useEffect is running"); // Check if this log appears
    const handleScroll = () => {
      const scrolled = document.documentElement.scrollTop;
      setShowScrollButton(scrolled > 100);
      console.log("Scrolled:", scrolled);
    };
  
    document.addEventListener("scroll", handleScroll); // or yourContainer.addEventListener
  
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };*/

  return (
    <div className={` `}>
      <div className="flex w-full  flex-col  bg-palette5">
        <div
          className="flex  w-full  flex-col  bg-no-repeat bg-center bg-cover bg-blue-black bg-opacity-60"
          style={{}}
        >
          <div
            className={`fixed top-0 left-0 right-0 z-50 w-full  transition-all ${
              showScrollButton ? "shadow-md" : ""
            }`}
          >
            <Navbar
              selectedPage={selectedPage}
              setSelectedPage={setSelectedPage}
              isMenuToggled={isMenuToggled}
              setIsMenuToggled={setIsMenuToggled}
              selectedDiv={selectedDiv}
              setSelectedDiv={setSelectedDiv}
            />
          </div>
          <div className="flex flex-1  ">
            <Routes>
              <Route
                path="/"
                element={
                  <HomePage
                    buttonHover={buttonHover}
                    setButtonHover={setButtonHover}
                    isMenuToggled={isMenuToggled}
                    setIsMenuToggled={setIsMenuToggled}
                    selectedDiv={selectedDiv}
                    setSelectedDiv={setSelectedDiv}
                    previousDiv={previousDiv}
                    setPreviousDiv={setPreviousDiv}
                    setSelectedPage={setSelectedPage}
                    setCompetence={setCompetence}
                  />
                }
              />
              <Route
                path="/home"
                element={
                  <HomePage
                    buttonHover={buttonHover}
                    setButtonHover={setButtonHover}
                    isMenuToggled={isMenuToggled}
                    setIsMenuToggled={setIsMenuToggled}
                    selectedDiv={selectedDiv}
                    setSelectedDiv={setSelectedDiv}
                    previousDiv={previousDiv}
                    setPreviousDiv={setPreviousDiv}
                    setSelectedPage={setSelectedPage}
                    setCompetence={setCompetence}
                  />
                }
              />
              <Route
                path="/en/index.html"
                element={
                  <HomePage
                    buttonHover={buttonHover}
                    setButtonHover={setButtonHover}
                    isMenuToggled={isMenuToggled}
                    setIsMenuToggled={setIsMenuToggled}
                    selectedDiv={selectedDiv}
                    setSelectedDiv={setSelectedDiv}
                    previousDiv={previousDiv}
                    setPreviousDiv={setPreviousDiv}
                    setSelectedPage={setSelectedPage}
                    setCompetence={setCompetence}
                  />
                }
              />
              <Route path="/about" element={<AboutPage />} />
              <Route
                path="/competences"
                element={
                  <CompetencesPage
                    competence={competence}
                    setCompetence={setCompetence}
                  />
                }
              />

              <Route path="/projects" element={<ProjectPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/contacts" element={<ContactUs />} />
              <Route
                path="/sub-competence/"
                element={
                  <SubCompetencesPage
                    competence={competence}
                    setCompetence={setCompetence}
                    subCompetence={subCompetence}
                    setSubCompetence={setSubCompetence}
                  />
                }
              />
              <Route
                path="/competence/"
                element={
                  <CompetencePage
                    competence={competence}
                    setCompetence={setCompetence}
                    subCompetence={subCompetence}
                    setSubCompetence={setSubCompetence}
                    selectedPage={selectedPage}
                    setSelectedPage={setSelectedPage}
                  />
                }
              />
            </Routes>
          </div>{" "}
          {showScrollButton && (
            <button
              onClick={scrollToTop}
              className="fixed bottom-4 right-4 bg-palette4 text-palette1 px-4 py-2 rounded-full shadow-lg hover:shadow-xl transition duration-300 ease-in-out"
            >
              <span className="mr-2">↑</span> {/* Unicode arrow */}
              Top
            </button>
          )}
          <Footer setSelectedPage={setSelectedPage} />
          {/*{showScrollButton && (
            <button
              onClick={scrollToTop}
              className="fixed bottom-4 right-4 bg-palette4 text-palette1 px-4 py-2 rounded-full shadow-lg hover:shadow-xl transition duration-300 ease-in-out"
            >
              Scroll to Top
            </button>
          )}*/}
        </div>
      </div>
    </div>
  );
}

export default App;
